import React from "react";
import "../../styles/App.css";
import Home from "./Home.jsx";

function App() {
  return <Home />;
}

export default App;
